import React from 'react'
import { Box } from '../../UI';
import { Typography } from '@material-ui/core';
import ProcessTypeSelect from '../../UI/ProcessTypeSelect';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import InputAdornment from '@material-ui/core/InputAdornment';
import FormControl from '@material-ui/core/FormControl';
import CurrencyField from '../../UI/CurrencyField';

export default function Fees() {
    
    const [values, setValues] = React.useState({
      amount: 10,
    });
    const handleChange = prop => event => {
      setValues({ ...values, [prop]: event.target.value });
    };

    return (
        <Box>
            <Typography variant='h5'><strong>Fees</strong></Typography>
            <Box mt='1rem' display='flex' justifyContent='space-between'>
                <ProcessTypeSelect 
                    label='Process Type'
                    variant="standard"
                    style={{width: '30%'}}
                />
                <CurrencyField style={{width: '30%'}} label='Auction cost (fixed)' helperText='0.015% of Ask price'/>
                <FormControl style={{width: '30%'}}>
                  <InputLabel htmlFor="standard-adornment-amount">Amount</InputLabel>
                  <Input
                    id="standard-adornment-amount"
                    value={values.amount}
                    onChange={handleChange('amount')}
                    startAdornment={<InputAdornment position="start">%</InputAdornment>}
                    type='number'
                  />
                </FormControl>
            </Box>
            <Box mt='1rem' display='flex' justifyContent='space-between' alignItems='flex-end'>
                <CurrencyField style={{width: '30%'}} label='Minimum ask price' helperText=''/>
                <Box style={{width: '30%'}}>
                    <Typography variant='body1'>Equivalent cap rate: 4.33%</Typography>
                </Box>
                <Box style={{width: '30%'}}>
                    <Typography variant='body1'>Probability of successful disposal: 97.2%</Typography>
                </Box>
            </Box>
            <Box mt='1rem' display='flex' justifyContent='space-between' alignItems='flex-end'>
                <CurrencyField style={{width: '30%'}} label='Letter of Intent charge' helperText=''/>
                <Box style={{width: '30%'}}>
                    <Typography variant='body1'>Charge as % of Ask price: 0.00059%</Typography>
                </Box>
                <Box style={{width: '30%'}}>
                    <Typography variant='body1'>Letter of Intent charge pot: £11,000</Typography>
                </Box>
            </Box>
        </Box>
    )
}
